import React, { useContext, useEffect, useState } from "react"; // Add useState
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

// alphabetized
import * as yup from "yup";
import qapi from "views_shared/app/javascript/api";
import SaveSpinnerButton from "./save_spinner_button";
import companySchema from "../../../yup_schemas/company_schema";
import { CompanyContext } from "../data/company_context_management";

function WebsiteUrlForm() {
  const context = useContext(CompanyContext);

  const { company, isUpdating, setIsUpdating, setDoTopLevelFetch } = context;

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(
      yup.object().shape({
        website_url: companySchema.fields.website_url,
      }),
    ),
  });

  const urlContactInfo = company.contact_details?.find((detail) => detail.type === "url") || {};
  const url = urlContactInfo.value;

  // Watch the website_url value
  const watchedWebsiteUrl = watch("website_url");

  // State to manage whether the Save button is enabled
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  useEffect(() => {
    setValue("website_url", url);
    setIsSaveEnabled(false); // Reset when the component is reloaded
  }, [company, setValue, url]);

  useEffect(() => {
    // Enable the Save button if the watched value is different from the initial value
    setIsSaveEnabled(watchedWebsiteUrl !== url);
  }, [watchedWebsiteUrl, url]);

  const onSubmit = async (data, event) => {
    event.preventDefault();
    setIsUpdating(true);

    const { website_url: websiteUrl } = data;

    let response;

    const contactInfoId = urlContactInfo.contact_info_id;
    if (contactInfoId) {
      if (websiteUrl.length === 0) {
        response = await qapi.contactInfos.deleteById(contactInfoId);
      } else {
        response = await qapi.contactInfos.updateById(contactInfoId, { value: websiteUrl });
      }
    } else {
      response = await qapi.contactInfos.createByContactOwner(company.id, "Id::PromoEntity::Company", {
        value: websiteUrl,
        value_type: "url",
      });
    }

    if (response.error) {
      const error = response.error?.body?.errors[0];
      setError("website_url", {
        type: "manual",
        message: error?.detail || "An error occurred",
      });
    } else {
      setDoTopLevelFetch(true);
      setIsSaveEnabled(false);
    }

    setIsUpdating(false);
  };

  return (
    // Top-aligned on purpose: centering re-centers the whole row when the validation message
    // appears, visibly shoving the field upward. Top alignment keeps label, field, and Save in
    // place and lets the message extend downward.
    <form onSubmit={(e) => e.preventDefault()} className="row g-2 align-items-start mb-2">
      <label htmlFor="website_url" className="col-sm-3 col-form-label">
        Website URL
      </label>
      <div className="col">
        <input
          type="url"
          className={`form-control ${errors?.website_url ? "is-invalid" : ""}`}
          defaultValue={url}
          id="website_url"
          placeholder="https://www.website.com/"
          pattern="https://.*"
          required
          {...register("website_url")}
        />
        {errors?.website_url && <div className="invalid-feedback">{errors?.website_url?.message}</div>}
      </div>
      <div className="col-auto">
        <SaveSpinnerButton
          activeText="Saving..."
          className={`${!isSaveEnabled ? "disabled" : ""}`}
          disabled={!isSaveEnabled}
          id="website-url-save"
          inactiveText="Save"
          isSaving={isUpdating}
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </form>
  );
}

export default WebsiteUrlForm;
